import { axios } from '@Root/API'

export const getFormEmails = params => {
  return axios.get('cognito-form-emails', { params })
}
